import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Router } from '@angular/router';
import { map } from 'rxjs/operators';
import { environment } from 'environments/environment';
import { CutsProjectModel } from '@core/model/custProject.model';
import { utiles } from '@utl/environment';
import { CommonService } from './common.service';
import { Injectable } from "@angular/core";
/*Constants */
const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };

@Injectable()
export class CutsProjectService {

  constructor(public http: HttpClient, private router: Router, private common: CommonService) {
    let data = utiles.getCacheUser();
    if (data !== null && data !== undefined) {
    } else {
      this.common._setLoading(false);
      this.router.navigate(['login']);
    }
  }

  getCustProjects(model: CutsProjectModel) {
    this.common._setLoading(true);
    const url = environment.apiURL + 'GetCustProjects';
    return this.http.post<CutsProjectModel[]>(url, JSON.stringify(model.CustAccount), httpOptions)
      .pipe(map(response => {
        this.common._setLoading(false);
        return response;
      }));
  }
}

